<script lang="ts">
  import { AppState } from '../../../etc/stores';

  const { primary200, primary600 } = $AppState.theme.colors;
</script>

<svg
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="40" height="40" rx="8" fill={primary600} />
  <path
    d="M30 25.6675V30.3341"
    stroke={primary200}
    stroke-width="1.90909"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M27.666 28.001H32.3327"
    stroke={primary200}
    stroke-width="1.90909"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M29.3 12.4286C30.35 12.7143 31.1 13.4286 31.4 14.4286C32 16.2857 32 20 32 20C32 20 32 21.6888 31.8621 23.3582C31.2866 23.1272 30.6581 23 30 23C27.2663 23 25.0449 25.1939 25.0007 27.9171C22.5081 28 20 28 20 28C20 28 12.35 28 10.55 27.5714C9.5 27.2857 8.75 26.5714 8.45 25.5714C8 23.7143 8 20 8 20C8 20 8 16.2857 8.3 14.4286C8.6 13.4286 9.35001 12.7143 10.4 12.4286C12.35 12 19.85 12 19.85 12C19.85 12 27.5 12 29.3 12.4286ZM23.9 20L17.6 16.5714V23.4286L23.9 20Z"
    fill={primary200}
  />
</svg>
